import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, tap } from 'rxjs';

/**
 * UnauthorizedInterceptor
 *
 * Este interceptor é responsável por lidar com respostas HTTP 401 (Não Autorizado) e realizar ações apropriadas,
 * como fazer logout do usuário ou redirecioná-lo para a página de login.
 */
@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {
  message =
    'Há algo de errado com a sua sessão. Por favor, vá para a página de login.';
  constructor(private router: Router) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse && event.status == 401) {
            if (!event.url?.includes('auth')) {
              this.router.navigateByUrl(`/forbidden`);
            }
          }
        },
        (error: any) => {
          if (error instanceof HttpErrorResponse && error.status == 401) {
            if (!error.url?.includes('auth')) {
              this.router.navigateByUrl(`/forbidden`);
            }
          }
        }
      )
    );
  }
}
